import React from "react";

/*** convert duration to standard format *******************/
function convertTostandardDurationFormat(timeStr) {
  // اگه فرمت درست بوده
  if (/^PT\d+H?(\d+M)?(\d+S)?$/.test(timeStr)) return timeStr;
  if (timeStr === null) {
    timeStr = "00:00:59";
  }
  const parts = timeStr.split(":").map(Number);
  const [hours, minutes, seconds] = parts;
  let duration = "PT";
  if (hours) duration += `${hours}H`;
  if (minutes) duration += `${minutes}M`;
  if (seconds) duration += `${seconds}S`;
  return duration;
}
const SchemaMarkup = (props) => {
  const regionName = props.region?.name || "";
const groupTitle = props.group?.title || "";
  /**** image *******************/
  const imageList = props.imagesListSlider.filter(
    (a) => a.gallery.option === 1
  );

  const images = imageList.map(
    (obj) => process.env.REACT_APP_API_URL + obj.gallery.imageUrl
  );
  /**** offer *******************/
  const offerString = {
    "@type": "Offer",

    availability: props.hasReserve
      ? "https://schema.org/InStock"
      : "https://schema.org/OutOfStock",
    url: window.location.origin + "/details/" + props.urlName,
  };

  offerString.price =
    props.price > 0 ? props.price  : props.originalPrice ;
  offerString.priceCurrency = "IRR";

  /**** seller *******************/
  // const sellerString = {
  //   "@type": "LocalBusiness",
  //   name: "تفریحان",
  //   address: {
  //     "@type": "PostalAddress",
  //     streetAddress:
  //       "جزیره کیش - بلوار میر مهنا - روبروی بازار پارس خلیج - مرکز نوآوری کیش - طبقه 4 - واحد 401 - شرکت رایان سفر نیکان کیش",
  //     addressLocality: "کیش",
  //     addressRegion: "هرمزگان",
  //     postalCode: "79415",
  //     addressCountry: "IR",
  //   },
  //   telephone: "+98-76-44100000",
  //   url: "https://www.tafrihan.com",
  // };
  // offerString.seller = sellerString;

  /**** product schema data  *******************/
  const productSchemaData = {
    "@context": "https://schema.org",
    "@type": "Product",
    name: props.pageTitle,
    description: props.metaDescription
      ? props.metaDescription
      : `${props.name} تجربه ای متفاوت از ${groupTitle} در شهر ${regionName} با تخفیف های واقعی، رزرو آنلاین، قیمت مناسب و پشتیبانی ۲۴ ساعته تفریحان. همین حالا انتخاب کن و یک روز هیجان انگیز بساز!`,
    productID: props.nameEn + "-001",
    image: images,
    brand: {
      "@type": "Brand",
      name: `تفریحات ${regionName}`,
    },
    offers: offerString,
  };
  //****testimonials ******************************** */

  if (props.amusementTestimonials && props.amusementTestimonials.length > 0) {
    productSchemaData.aggregateRating = {
      "@type": "AggregateRating",
      ratingValue: props.totalRank,
      bestRating: "5",
      worstRating: "0",
      reviewCount: props.amusementTestimonials.length,
    };

    productSchemaData.review = props.amusementTestimonials.map((r) => ({
      "@type": "Review",
      author: {
        "@type": "Person",
        name: r.name,
      },
      reviewBody: r.text,
      reviewRating: {
        "@type": "Rating",
        ratingValue: r.totallyRank,
        bestRating: "5",
      },
    }));
  }
  /*** video Schema data *************************/
  // let videoSchemaData = "";
  // if (props.videos?.length > 0) {
  //   videoSchemaData = {
  //     "@context": "https://schema.org",
  //     "@graph": props.videos.map((video) => ({
  //       "@type": "VideoObject",
  //       name: video.imageAlt,
  //       description: video.description,
  //       thumbnailUrl: process.env.REACT_APP_API_URL + props.mainListImage,
  //       uploadDate: video.created,
  //       duration: convertTostandardDurationFormat(video.duration),
  //       contentUrl: process.env.REACT_APP_API_URL + video.imageUrl,
  //       mainEntityOfPage: window.location.origin + "/details/" + props.urlName,
  //     })),
  //   };
  // } else videoSchemaData = "";

  /*** breadcrumb schema data *************************/
const breadcrumbSchemaData = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "خانه",
      "item": "https://www.tafrihan.com/"
    },
    {
      "@type": "ListItem",
      "position": 2,
      "name": regionName,
      "item": `https://www.tafrihan.com/c/${props.region?.englishName}`
    },
    {
      "@type": "ListItem",
      "position": 3,
      "name": groupTitle,
      "item": `https://www.tafrihan.com/c/${props.region?.englishName}/${props.group?.urlName}`
    },
    {
      "@type": "ListItem",
      "position": 4,
      "name": props.name, 
      "item": `https://www.tafrihan.com/details/${props.urlName}`
    }
  ]
};

  /*** location Schema data *************************/
  // const locationSchemaData = {
  //   "@context": "https://schema.org",
  //   "@type": "TouristAttraction",
  //   name: props.name,
  //   description: props.metaDescription
  //     ? props.metaDescription
  //     : `${props.name} تجربه ای متفاوت از ${props.groupName} در شهر ${
  //         props.region.split("،")[0]
  //       } با تخفیف های واقعی، رزرو آنلاین، قیمت مناسب و پشتیبانی ۲۴ ساعته تفریحان. همین حالا انتخاب کن و یک روز هیجان انگیز بساز!`,
  //   image: images,
  //   address: {
  //     "@type": "PostalAddress",
  //     addressLocality: props.region.split("،")[0],
  //     addressCountry: "IR",
  //   },
  //   geo: {
  //     "@type": "GeoCoordinates",
  //     latitude: props.lat,
  //     longitude: props.lon,
  //   },
  //   url: window.location.origin + "/details/" + props.urlName,
  // };
  /****************************/
  return (
    <>
      {Number(props.originalPrice) > 0 && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(productSchemaData),
          }}
        />
      )}
      {/* {props.videos?.length > 0 && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(videoSchemaData) }}
        />
      )} */}
  <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(breadcrumbSchemaData),
      }}
    />
      {/* {props.lat && props.lon && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(locationSchemaData) }}
        />
      )} */}
    </>
  );
};

export default SchemaMarkup;
